// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2FGnR","HideIcon":"HideIcon--2L7yD"};